import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from '@/network/request'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userList: {},
    userInfo: null, // 用户信息
    count: 1,
    sectionAndChapter: null,
    loginDialogVisible: false,
    loginDialogSuccess: () => {},
  },
  mutations: {
    loginDialogOpen(state) {
      state.loginDialogVisible = true
    },
    loginDialogClose(state) {
      state.loginDialogVisible = false
      state.loginDialogSuccess = () => {}
    },
    setUser(state, data = null) {
      if (data === null) {
        state.userInfo = data
      } else {
        let info
        if (state.userInfo === null) {
          info = {}
          localStorage.removeItem('info')
        } else {
          // 将state.userInfo中所有可枚举的属性，复制到{}中
          info = Object.assign({}, state.userInfo)
        }
        for (const i in data) {
          info[i] = data[i]
        }
        state.userInfo = info
        // 本地存储和vuex结合使用
        localStorage.setItem('info', JSON.stringify(info))
      }
    },
    SET_SECTIONADCHAPTER(state, data) {
      state.sectionAndChapter = data
    },
  },
  actions: {
    async setUser(context, data = null) {
      if (data === null) {
        if (localStorage.getItem('user-token')) {
          // 打开网站直接跳登录页，毛病
          const res = await getUserInfo()
          if (res.data.result) {
            const info = {
              nickname: res.data.result.nickname,
              headpic: res.data.result.headpic,
              sex: res.data.result.sex,
              phone_hide: res.data.result.phone_hide,
            }
            context.commit('setUser', info)
          } else {
            return false
          }
        }
      } else {
        await context.commit('setUser', data)
      }
    },

    // 检查登录状态并执行回调函数
    async loginNext(context, success = null) {
      let userInfo = context.state.userInfo
      let userToken = localStorage.getItem('user-token')
      if (userInfo && userToken) {
        context.state.loginDialogSuccess(userInfo, userToken)
        return false
      } else {
        if (typeof success == 'function') {
          context.state.loginDialogSuccess = success
        } else {
          context.state.loginDialogSuccess = () => {}
        }
        await context.commit('loginDialogOpen')
      }
    },
  },
  modules: {},
})
